import React from 'react';
import {EfeCatalog} from 'commons/models';

type EfeCatalogContextType = {
    catalogs: Array<EfeCatalog>;
    updateCatalogs: (data: EfeCatalog) => void;
    uploadData: (data: Array<EfeCatalog>) => void;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const OnboardingCatalogContext = React.createContext<EfeCatalogContextType>({});

export function useCatalogContext() {
    return React.useContext(OnboardingCatalogContext);
}

export default OnboardingCatalogContext;
